import { computed, type ComputedRef } from 'vue'
import { useSamudkoyStore } from '../../stores/samudkoy'

interface UseTextPage {
  page: ComputedRef<number>
}

//------------------------------------------------
export function useTextPage(): UseTextPage {
  const samudkoyStore = useSamudkoyStore()

  const page = computed(() => samudkoyStore.page)

  return {
    page,
  }
}

//------------------------------------------------
export function useTextPageMock(): UseTextPage {
  const page = computed(() => 1)

  return {
    page,
  }
}
